import { Redirect, Route, Switch } from 'react-router-dom';

import ProtectedRoute from 'components/routes/ProtectedRoute';
import InitialSetupPage from 'features/home/InitialSetupPage';
import ProjectSetupPage from 'features/projectSetup';
import TermsAndConditionsPage from 'features/home/TermsAndConditionsPage';
import HomePage from 'features/home/HomePage';
import ProjectsPage from 'features/projects/ProjectsPage';
import EmailVerificationPage from 'features/home/EmailVerificationPage';
import ProfileComplete from 'features/home/ProfileComplete';
import ProjectDetailsPage from 'features/projectSummary';
import { Content } from 'antd/lib/layout/layout';
import ProjectSider from './components/AppLayout/Sider';
import ProjectStoreDetailsPage from 'features/storeDetails';
import BuildsPage from 'features/builds';
import BuildDetailsPage from 'features/builds/BuildDetailsPage';
import CollaboratorsPage from './features/collaborators';
import { CollaboratorPermission } from './api';
import withPermissionCheck from 'components/routes/withPermissionCheck';
import FinancePage from 'features/finance/FinancePage';
import PublishingRequirementsPage from 'features/publishingRequirements';
import InvitationPage from 'features/invitation';
import TestInvitationPage from 'features/testInvitation/TestInvitationPage';
import PlayersPage from 'features/players/PlayersPage';
import GameServicesPage from 'features/gameServices/GameServicesPage';
import AchievementsPage from 'features/gameServices/achievements/AchievementsPage';
import CreateAchievementPage from 'features/gameServices/achievements/CreateAchievementPage';
import RedemptionCodesPage from 'features/redemptionCode';
import AnalyticsPage from 'features/analytics/AnalyticsPage';
import GameStatsPage from 'features/gameServices/stats/GameStatsPage';
import CreateGameStatsPage from 'features/gameServices/stats/CreateGameStatsPage';
import EditGameStatsPage from 'features/gameServices/stats/EditGameStatsPage';
import LeaderboardsPage from 'features/gameServices/leaderboards/LeaderboardsPage';
import LeaderboardsV2Page from 'features/gameServices/leaderboardsV2/LeaderboardsPage';
import DownloadableContent from 'features/gameServices/downloadableContent/DownloadableContent';
import EditDownloadableContent from 'features/gameServices/downloadableContent/EditDownloadableContent';
import CreateLeaderboardPage from 'features/gameServices/leaderboards/CreateLeaderboardPage';
import CreateLeaderboardV2Page from 'features/gameServices/leaderboardsV2/CreateLeaderboardPage';
import EditLeaderboardPage from './features/gameServices/leaderboards/EditLeaderboardPage';
import EditLeaderboardV2Page from './features/gameServices/leaderboardsV2/EditLeaderboardPage';
import GetStartedPage from './features/getStarted/GetStartedPage';
import DownloadsPage from './features/downloads/DownloadsPage';
import SupportPage from './features/support/SupportPage';
import DocumentationPage from 'features/documentation/DocumentationPage';
import EditAchievementPage from 'features/gameServices/achievements/EditAchievementPage';
import React from 'react';

export default React.memo((Router) => {
	return (
		<Switch>
			<Route>
				<Content className="page-content">
					<Switch>
						<ProtectedRoute path="/profile-setup" exact component={InitialSetupPage} />
						<ProtectedRoute path="/toc" exact component={TermsAndConditionsPage} />
						<ProtectedRoute path="/email-verification" exact component={EmailVerificationPage} />
						<ProtectedRoute path="/profile-information" exact component={ProfileComplete} />
						<Route path="/get-started" exact component={GetStartedPage} />
						<Route path="/" exact component={HomePage} />
						<Redirect from="*" to="/" />
					</Switch>
				</Content>
			</Route>
		</Switch>
	);
});
